import { render, staticRenderFns } from "./success.vue?vue&type=template&id=53ddbbd3&scoped=true&"
import script from "./success.vue?vue&type=script&lang=js&"
export * from "./success.vue?vue&type=script&lang=js&"
import style0 from "./success.vue?vue&type=style&index=0&lang=less&"
import style1 from "./success.vue?vue&type=style&index=1&id=53ddbbd3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ddbbd3",
  null
  
)

export default component.exports